<template>
<div>
    <div class="page-footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-5">
                    <div class="copyright">2011-{{ new Date().getFullYear() }} © {{ project }} {{ appType }}. All Rights Reserved </div>
                </div>
                <div class="col-md-7 footer-links">
                    <a target="_blank" href="https://smartyads.com/services-privacy-policy">Privacy Policy</a>
                    <a target="_blank" href="https://smartyads.com/services-privacy-policy">Do not sell my personal information</a>
                </div>
            </div>
        </div>
    </div>
    <ButtonScrollTop/>
</div>
</template>

<script>
import ButtonScrollTop from "@/js/components/Buttons/ButtonScrollTop.vue";

export default {
    name: "AppFooter",
    components: { ButtonScrollTop },
    data: () => ({
        project: import.meta.env.VITE_APP_NAME,
        appType: import.meta.env.VITE_APP_TYPE,
        appLogo: import.meta.env.VITE_APP_LOGO_HEADER,
    }),
}
</script>

<style lang="scss" scoped>
    .footer-links {
        a {
            margin-right: 10px;
        }
    }
</style>
